import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MachineService, MachineId } from '../../services/machine.service';
import { ActivityService } from '../../services/activity.service';
import { toast, MaterializeAction } from 'angular2-materialize';
import { UnitService } from '../../services/unit.service';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-display-machine',
  templateUrl: './display-machine.component.html',
  styleUrls: ['./display-machine.component.css']
})
export class DisplayMachineComponent implements OnInit, OnDestroy {
  loading: boolean[] = Array(2).fill(false);
  get loaded(): boolean { return !this.loading.includes(false); }

  id: string = '';

  form: FormGroup;

  activitys: any = {};
  activityIds: string[] = [];
  units: any = {};

  pickadateParams = Utils.pickadateParams();

  subs: Subscription[] = [];

  constructor(
    private service: MachineService,
    private activityService: ActivityService,
    private unitService: UnitService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.id = activatedRoute.snapshot.paramMap.get('id');

    this.subs.push(
      this.activityService.getActivities({ onEmpty: () => { this.loading[0] = true; } }).subscribe(activitys => {
        activitys.map(({id, name, activityClassObj: {name: classification}}) => {
          this.activitys[id] = {name, classification};
        })
        this.loading[0] = true;
      })
    );
    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      this.units = units.reduce((acc, cur) => ({ [cur.id]: `${cur.name} - ${cur.symbol}`, ...acc }), {} );
      this.subs.push(
        service.getMachine(this.id).subscribe(({maxWidthUnitId, maxLongUnitId, clawWidthUnitId, clawLongUnitId, ...machine}) => {
          machine.maxWidth += ` ${this.units[maxWidthUnitId]}`;
          machine.maxLong += ` ${this.units[maxLongUnitId]}`;
          machine.clawWidth += ` ${this.units[clawWidthUnitId]}`;
          machine.clawLong += ` ${this.units[clawLongUnitId]}`;
          this.form.patchValue(machine);
          this.activityIds = machine.activityIds;
          this.loading[1] = true;
        })
      );
    });
  }

  ngOnInit() {
    this.createForm();
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm() {
    this.form = this.fb.group({
      folio: ['', Validators.required],
      name: ['', Validators.required],
      date: '',
      warrantyTime: '',
      notes: '',
      headers: '',
      maxWidth: '',
      maxWidthUnitId: '',
      maxLong: '',
      maxLongUnitId: '',
      clawWidth: '',
      clawWidthUnitId: '',
      clawLong: '',
      clawLongUnitId: '',
    });
  }

}
